import { useContext } from "react"
import { MobXProviderContext } from "mobx-react"
import { AppModels } from "@models"

export function useStore() {
  return useContext(MobXProviderContext) as AppModels
}
